<template>
  <div class="new-drawer-form">
    <span class="drawer-title" style="display:block">行业薪酬：</span>
    <div class="drawer-salary-search">
      <div class="new-drawer-salary-cate mb10">选择行业，职能，职级可查询对应薪酬</div>
      <div class="drawer-salary-form-item mb10">
        <div class="drawer-salary-form-label mr10"><span>*</span>行业</div>
        <el-select v-model="form.行业" size="mini" placeholder="请选择行业" @change="hangyeChange">
          <el-option label="公募基金" value="公募基金"></el-option>
          <el-option label="证券" value="证券"></el-option>
          <el-option label="PE" value="PE"></el-option>
          <el-option label="医药" value="医药"></el-option>
        </el-select>
      </div>
      <div class="drawer-salary-form-item mb10">
        <div class="drawer-salary-form-label mr10"><span>*</span>职能模块</div>
        <el-select v-model="form.职能模块" size="mini" placeholder="请选择职能模块" filterable :disabled="!this.form.行业" @change="cateChange">
          <el-option v-for="(opt, k) in cateOpt" :key="k" :label="opt" :value="opt"> </el-option>
        </el-select>
      </div>
      <div class="drawer-salary-form-item mb10">
        <!-- <div class="drawer-salary-form-label"></div> -->
        <div class="drawer-salary-form-label mr10" style="margin-left:40px">细分职能</div>
        <el-select v-model="form.细分职能" size="mini" placeholder="请选择细分职能" filterable :disabled="!this.form.行业 || !this.form.职能模块">
          <el-option v-for="(opt, k) in xiOpt" :key="k" :label="opt" :value="opt"> </el-option>
        </el-select>
      </div>
      <div class="drawer-salary-form-item mb10">
        <!-- <div class="drawer-salary-form-label"></div> -->
        <div class="drawer-salary-form-label mr10" style="margin-left:40px">擅长方向</div>
        <el-select v-model="form.擅长方向" size="mini" placeholder="请选择擅长方向" filterable :disabled="!this.form.行业 || !this.form.职能模块">
          <el-option v-for="(opt, k) in shanOpt" :key="k" :label="opt" :value="opt"> </el-option>
        </el-select>
      </div>
      <div class="drawer-salary-form-item mb10">
        <div class="drawer-salary-form-label mr10"><span> </span>职级</div>
        <el-select v-model="form.职级" size="mini" placeholder="请选择职级">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(opt, k) in zhijiOpt" :key="k" :label="opt" :value="k"> </el-option>
        </el-select>
      </div>
      <div class="drawer-salary-form-item mb10" style="flex-direction: row-reverse;">
        <el-button type="primary" size="mini" @click="doSearch">确定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      form: {},
      cateOpt: [],
      xiOpt: [],
      shanOpt: [],
      zhijiOpt: [],
      zyzj: {
        MD: 'MD',
        ED: 'ED',
        D: 'D',
        AD: 'AD',
        VP: 'VP',
        A: 'A',
        AN: 'AN',
      },
      zj: {
        '1': '1.高管',
        '2': '2.部门总',
        '3': '3.部门副总/总助/团队长',
        '4': '4.部门核心骨干',
        '5': '5.新人三年以下',
      },
    }
  },
  async mounted() {
    await this.loadCate()
  },
  methods: {
    async loadCate() {
      if (!app.categories) await app.getCats()
      const cateData = app.categories
      if (cateData && cateData.length > 0) {
        this.cateData = cateData
        const tmp = cateData.map(item => item['名称'])
        this.cateOpt = JSON.parse(JSON.stringify(tmp))
      }
    },
    async hangyeChange() {
      this.zhijiOpt = this.form.行业 === '证券' ? this.zyzj : this.zj
      if (this.form.行业 && app.service('radish').getHangyeSalaryCatesByIndustry) {
        const res = await app.service('radish').getHangyeSalaryCatesByIndustry({行业:this.form.行业})
        if (res.status == 'success') {
          this.cateOpt = res.data.职能模块.filter(c=>c.indexOf(';') == -1 && c.indexOf(',') == -1)
        } else {
          this.cateOpt = []
        }
        delete this.form.职能模块
        delete this.form.细分职能
        delete this.form.擅长方向
      }
    },
    cateChange() {
      if (this.form.职能模块) {
        const filtered = this.cateData.filter(c => c.名称 === this.form.职能模块)
        this.xiOpt = filtered[0].二级职能 || []
        this.shanOpt = filtered[0].擅长方向 || []
        delete this.form.细分职能
        delete this.form.擅长方向
      }
    },
    async doSearch() {
      const form = this.form
      if (!form.行业) return this.$message('请选择行业')
      if (!form.职能模块) return this.$message('请选择职能')
      this.$emit('doSearch', { type: '行业薪酬', keywords: this.form })
    },
  },
}
</script>
<style scoped>
.new-drawer-salary-cate {
  /* padding: 3px 5px;
  background-color: #2478b526;
  color: #c1c1c1;
  border-radius: 2px;
  margin: 5px;
  text-align: center; */
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.25);
  line-height: 22px;
}
/* .new-drawer-salary-cate::after {
  content: '';
  display: block;
  width: 0px;
  height: 7px;
  border-top: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 9px solid #2478b526;
  border-left: 7px solid transparent;
  position: absolute;
  left: 10px;
  top: -20px;
} */
.drawer-salary-form-item.mb10 {
  margin-bottom: 10px;
}
.new-drawer-salary-cate.mb10 {
  margin-bottom: 10px;
}
.drawer-salary-form-label {
  word-break: keep-all;
  white-space: nowrap;
}
.drawer-title {
  padding-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #262626;
}
</style>
